import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";
import { UserListComponent } from "../user-list/user-list.component";
import { UserService } from "../user.service";
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from "../../views/confirm/confirm.component";

@Component({
  selector: "app-user-add",
  templateUrl: "./user-add.component.html",
  styleUrls: ["./user-add.component.scss"],
})
export class UserAddComponent implements OnInit {
  public userId: number;
  public overallRating: number;
  isViewOnly: boolean = false;
  public userdate;
  isEditable: boolean = false;
  public userForm: UntypedFormGroup;
  public imagePath: String;

  @ViewChild(UserListComponent) child: UserListComponent;
  constructor(private simpleModalService: SimpleModalService, private toastr: ToastrService, private userService: UserService) {

    this.userForm = new UntypedFormGroup({
      first_name: new UntypedFormControl("", [
        Validators.required,
        // Validators.pattern("^[a-zA-Z]+$"),
      ]),
      last_name: new UntypedFormControl("", [
        Validators.required,
        // Validators.pattern("^[a-zA-Z]+$"),
      ]),
      phone_number: new UntypedFormControl("", [
        Validators.required,
        //Validators.pattern("P[0-9]*6"),
      ]),
      email: new UntypedFormControl("", [
        Validators.maxLength(30),
        Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i),
        Validators.required
      ]),

      company_name: new UntypedFormControl("", [
        // Validators.required
      ]),
      business_address: new UntypedFormControl("", [
        // Validators.required
      ]),
      business_type: new UntypedFormControl("", [
        // Validators.required
      ]),
      tax_number: new UntypedFormControl("", [
        // Validators.required
      ]),
      license_pic: new UntypedFormControl("", [
        // Validators.required
      ]),
    });
  }

  ngOnInit() {
    console.log("working");
    console.log(this.userId);
    if (this.userId) {
      this.userService.getUserById(this.userId).subscribe((usr: any) => {
        console.log(usr.userDetails);
        this.userdate = usr.userDetails;
        this.userForm.patchValue({
          first_name: usr.userDetails.first_name,
          last_name: usr.userDetails.last_name,
          phone_number: usr.userDetails.phone_number,
          email: usr.userDetails.email,
          company_name: usr.userDetails.company_name,
          business_address: usr.userDetails.business_address,
          business_type: usr.userDetails.business_type,
          tax_number: usr.userDetails.tax_number
        });
        this.imagePath = usr.userDetails.profile_pic;
        this.isEditable = true;
      });

      this.userService.getUserRatingById(this.userId).subscribe((usr: any) => {
        this.overallRating = parseFloat(usr.customerData[0].overallRating.$numberDecimal);
      });
    }
  }

  submitted = false;
  onSubmitUser() {
    this.submitted = true;
    console.log('this.userForm.valid', this.userForm.valid)
    if (this.userForm.valid) {
      if (this.isEditable === false) {
        this.userService.createUser(this.userForm.value).subscribe(() => {
          this.toastr.success('User has been created.');
        }, err => {
          this.toastr.error(err.error.message);
        });
      } else {
        console.log("working");
        let userData = this.userForm.value;
        userData.user_id = this.userId;
        var formData: any = new FormData();
        formData.append("business_address", userData.business_address);
        formData.append("business_type", userData.business_type);
        formData.append("company_name", userData.company_name);
        formData.append("email", userData.email);
        formData.append("first_name", userData.first_name);
        formData.append("last_name", userData.last_name);
        formData.append("phone_number", userData.phone_number);
        formData.append("tax_number", userData.tax_number);
        formData.append("user_id", userData.user_id);
        console.log("🚀 ~ file: user-add.component.ts ~ line 109 ~ UserAddComponent ~ onSubmitUser ~ userData.profile_pic", userData.profile_pic)
        if (userData.license_pic) {
          formData.append("license_pic", userData.license_pic);
        }
        this.userService
          .putUser(this.userId, formData)
          .subscribe(() => {
            this.userService.closeOverlay();
            this.userService.onCompleted();
            this.toastr.success('User has been updated.');
          }, err => {
            this.toastr.error(err.error.message);
          });
      }

      this.submitted = false;

    } else {
      Object.keys(this.userForm.controls).forEach(key => {

        const controlErrors: ValidationErrors = this.userForm.get(key).errors;
        if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          });
        }
      });
    }
  }

  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    console.log("🚀 ~ file: user-add.component.ts ~ line 138 ~ UserAddComponent ~ uploadFile ~ file", file)
    this.userForm.patchValue({
      license_pic: file
    });
    // this.userForm.get('avatar').updateValueAndValidity()
  }

  changeuserStatus(status) {
    this.userService.updateUserApprovStatus(this.userId, status).subscribe(() => {

      this.userService.closeOverlay();
      this.userService.onCompleted();
      this.toastr.success('User status has been updated.');

    }, err => {
      this.toastr.error(err.error.message);
    });

    // this.simpleModalService.addModal(ConfirmComponent, {
    //   title: 'Please Confirm',
    //   message: 'Are sure you want to update Status?'
    // }).subscribe((isConfirmed) => {
    //   if (isConfirmed) {

    //   }
    // });
  }

  clearValue() {
    this.userForm.reset();
  }

  public closeForm() {
    this.userService.closeOverlay();
  }

  onClickDownload(e, columnName){
    if (this.userdate[columnName].match(/\.(jpeg|jpg|gif|png)$/) != null) {
      console.log(this.userdate[columnName])
      console.log(columnName)
      e.preventDefault();
      var link = document.createElement('a');
      link.href = this.userdate[columnName];
      // link.download = 'Download.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.toastr.error('Image Not Found');
    }
    return false;
  }

}
